import { useProjectDetailsContext } from 'pages/projects/details/project-details-layout'

import { useAuthUser } from './use-auth'

export const useCurrentUser = () => {
  const { userId } = useAuthUser()

  const {
    project: { team },
  } = useProjectDetailsContext()

  return team.find(teamMember => teamMember.userId === userId)!
}
